import { HttpClient } from '@angular/common/http';
import { AfterViewChecked, Component, ElementRef, OnChanges, OnInit, QueryList, SimpleChange, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { HelpItemComponent } from '../help-item.component'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslationService } from '../../../services/translation.service';

interface MenuItem {
	title: string;
	id: string;

}
@Component({
	selector: 'howto',
	styleUrls: ['./howto.component.less'],
	templateUrl: './howto.component.html'
})
export class HowToComponent
	extends HelpItemComponent
	implements OnInit
	//, AfterViewChecked
{
	content: SafeHtml;
	menu: MenuItem[] = [];
	@ViewChild('viewContent') viewContent: ElementRef;
	constructor(private http: HttpClient,
		private dom: DomSanitizer,
		private trans: TranslationService) {
		super();
	}

	ngOnInit() {
		this.load(this.http, this.dom, this.trans.lang, 'howto').then(data => this.content = data);
	}

	//onMenuClick(id: string) {
	//	const element = this.viewContent?.nativeElement as HTMLElement;
	//	if (element == null)
	//		return;
	//	const el = element.querySelector("#" + id);
	//	if (el == null)
	//		return;
	//	el.scrollIntoView({
	//		behavior: 'smooth',
	//		block: 'start',
	//		inline: 'start'
	//	});
	//}
	//ngAfterViewChecked() {
	//	if (this.menu.length != 0)
	//		return;
	//	const element = this.viewContent?.nativeElement as HTMLElement;
	//	if (element?.firstChild == null)
	//		return;
	//	setTimeout(() => {
	//		if (this.menu.length != 0)
	//			return;
	//		const elems = element.getElementsByTagName('h1');
	//		const newMenu: MenuItem[] = [];
	//		for (let i = 0; i < elems.length; i++) {
	//			elems[i].id = 'ht' + i;
	//			newMenu.push({
	//				id: elems[i].id,
	//				title: elems[i].innerText
	//			});
	//		}
	//		this.menu = newMenu;
	//	});
	//}
}
